import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';

export const escrowCompanySuccess = payload => {
  return {
    type: actionTypes.ESCROW_COMPANIES_SUCCESS,
    payload: payload
  };
};

export const escrowCompanyStart = () => {
  return {
    type: actionTypes.ESCROW_COMPANIES_START
  };
};

export const escrowCompanyFail = error => {
  return {
    type: actionTypes.ESCROW_COMPANIES_FAIL,
    error: error
  };
};
export const getEscrowCompaniesList = (getData, hideLoader) => {
  return dispatch => {
    if (!(hideLoader !== undefined && hideLoader === true)) {
      //dispatch(escrowCompanyStart());
    }
    axiosInstance()
      .get('/escrow-companies.json', { params: getData })
      .then(response => {
        dispatch(escrowCompanySuccess({ ...response.data, loaded: true }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(escrowCompanyFail(err.response.data.message));
        } else {
          dispatch(escrowCompanyFail('Problem with connection to API.'));
        }
      });
  };
};

export const createEscrowCompany = (postData, history) => {
  return dispatch => {
    dispatch(escrowCompanyStart());
    axiosInstance()
      .post('/escrow-companies.json', postData)
      .then(response => {
        history.push('/escrow-companies/' + response.data.id);
        dispatch(escrowCompanySuccess({ list: [], loaded: false }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(escrowCompanyFail(err.response.data.message));
        } else {
          dispatch(escrowCompanyFail('Problem with connection to API.'));
        }
      });
  };
};

export const editEscrowCompany = (entityId, postData, callback) => {
  return dispatch => {
    dispatch(escrowCompanyStart());
    axiosInstance()
      .put(`/escrow-companies/${entityId}.json`, postData)
      .then(response => {
        dispatch(escrowCompanySuccess({ viewItem: response.data }));
        dispatch(escrowCompanySuccess({ list: [], loaded: false }));
        callback();
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(escrowCompanyFail(err.response.data.message));
        } else {
          dispatch(escrowCompanyFail('Problem with connection to API.'));
        }
      });
  };
};

export const getEscrowCompany = entityId => {
  return dispatch => {
    //dispatch(loaderStart());
    axiosInstance()
      .get('/escrow-companies/' + entityId + '.json')
      .then(response => {
        dispatch(escrowCompanySuccess({ viewItem: response.data }));
        //dispatch(loaderStop());
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(escrowCompanyFail(err.response.data.message));
        } else {
          dispatch(escrowCompanyFail('Problem with connection to API.'));
        }
        //dispatch(loaderStop());
      });
  };
};
